// Single dispatcher for all /demo/:slug routes.
// Decides which demo template to render based on the slug.

import { useParams } from 'react-router-dom'
import { BOOKING_CONFIGS, ORDER_CONFIGS, TRADES_CONFIGS } from './configs'
import BookingDemo from './BookingDemo'
import OrderDemo from './OrderDemo'
import TradesDemo from './TradesDemo'
import SpaHotelDemo from './SpaHotel'
import RestaurantDemo from './Restaurant'
import WineryDemo from './Winery'
import NotFound from '../pages/NotFound'

export default function DemoRouter() {
  const { slug } = useParams<{ slug: string }>()
  if (!slug) return <NotFound />

  if (slug in BOOKING_CONFIGS) return <BookingDemo slug={slug} />
  if (slug in ORDER_CONFIGS) return <OrderDemo slug={slug} />
  if (slug in TRADES_CONFIGS) return <TradesDemo slug={slug} />
  if (slug === 'spa-hotel') return <SpaHotelDemo />
  if (slug === 'restaurant') return <RestaurantDemo />
  if (slug === 'winery') return <WineryDemo />

  return <NotFound />
}
